import React from 'react'
import './styles.scss'
interface Props {
  src: string
  annotations: annotationType[]
  ground?: groundPropType
}

export const Image = ({ src, annotations, ground }: Props) => (
  <div className='Image wrapper'>
    {ground && (
      <div
        className='ground'
        style={{
          top: ground.y + '%',
          backgroundColor: ground.color
        }}
      />
    )}
    <img src={src} />
    {annotations.map(anno => {
      return (
        <div
          className='annotation'
          style={{
            left: anno.pos.x + '%',
            top: anno.pos.y + '%',
            textAlign: anno.align ? anno.align : 'left',
            maxWidth: anno.maxWidth ? anno.maxWidth + '%' : 'inherit'
          }}
        >
          {anno.text}
          {anno.arrow && (
            <img
              src={require(`images/arrow_${anno.arrow.type}.svg`)}
              style={{
                width: '30px',
                position: 'absolute',
                ...anno.arrow.pos
              }}
            />
          )}
        </div>
      )
    })}
  </div>
)
